// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {successAlert, errorAlert} from '@alert'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('aboutGoals/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('aboutGoals/getData', async params => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/our-goal', params)

  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})





export const getUser = createAsyncThunk('aboutGoals/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.data
})

export const updateUser = createAsyncThunk('aboutGoals/updateUser', async (params, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + '/api/dashboard/our-goals', params.user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().aboutGoals.params))
  // await dispatch(getAllData())
  return params.user
})


export const addUser = createAsyncThunk('aboutGoals/addUser', async (user, { dispatch, getState }) => {
  await axios.put(process.env.REACT_APP_BASE_URL + '/api/dashboard/our-goals' ,user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().aboutGoals.params))
  
  return user
})

export const aboutGoalsSlice = createSlice({
  name: 'aboutGoals',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default aboutGoalsSlice.reducer
